<div class="main-content">
	<div class="container-fluid">
		<div class="card">
			<div class="card-header card-header-{{color}}-1">
				<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Open Quotes</h4>
				<p class="card-category text-right">Open Quotes</p>
			</div>
			<div class="card-body">
				<app-quote-list [customerdata]="''" (orderloaded)="selectItemLookup($event)" (orderinvoice)="invoiceOrder($event)"></app-quote-list>
			</div>
		</div>
	</div>
</div>
